import { render, staticRenderFns } from "./ReSetPassword.vue?vue&type=template&id=13594420"
import script from "./ReSetPassword.vue?vue&type=script&lang=js"
export * from "./ReSetPassword.vue?vue&type=script&lang=js"
import style0 from "./ReSetPassword.vue?vue&type=style&index=0&id=13594420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports